import { render, staticRenderFns } from "./SessionsWidget.vue?vue&type=template&id=cfa21628&scoped=true"
import script from "./SessionsWidget.vue?vue&type=script&lang=js"
export * from "./SessionsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa21628",
  null
  
)

export default component.exports